<script>
    import PropertyTable from "../../common/property-table.vue";
    import TextField from "../../common/text-field.vue";
    import DialogHeader from "../../dialog/components/dialog-header.vue";
    import DialogBase from "../../dialog/components/dialog-base.vue";
    import DialogBody from "../../dialog/components/dialog-body.vue";
    import DialogActionbar from "../../dialog/components/dialog-actionbar.vue";
    import Loading from "../../common/loading.vue";
    import API from "../../../API";
    import toaster from "../../common/toaster";

    export default {
        name: "tag-dialog",
        components: {Loading, DialogActionbar, DialogBody, DialogBase, DialogHeader, TextField, PropertyTable},
        data(vm) {
            const name = Lang.langGet('Name');
            const mustEnter = Lang.langGet('You must enter a ');
            const doesntDiffer = Lang.langGet('No changes made')

            return {
                showDialog: false,
                processing: false,
                invalid: true,
                name: '',
                initialName: '',
                id: undefined,

                nameRules: {
                    required: value => !!value || mustEnter + name
                }
            }
        },
        computed: {
            translations() {
                return {
                    placeholder: Lang.langGet('New tag name'),
                    screenName: Lang.langGet('Tag name'),
                    addTag: Lang.langGet('Add new tag'),
                    editTag: Lang.langGet('Edit tag'),
                    name: Lang.langGet('Name'),
                    addedSuccessfully: Lang.langGet('Tag :name added successfully', {name: this.name}),
                    saveError: Lang.langGet('Tag :name could no be added', {name: this.name})
                }
            },
        },
        watch: {
            name(newName) {
                this.invalid = !newName;
            }
        },
        methods: {
            show() { this.showDialog = true; },
            hide() { this.showDialog = false; },
            refreshList() {
                EaseEventBus.fire('reloadTagTable');
            },
            handleClose() { this.hide(); },
            handleChange(newName) {
                this.name = newName;
            },
            async handleSave() {
                this.processing = true;
                const url = this.id
                    ? '/administration/tag/edit'
                    : '/administration/tag/add';
                const api = new API(url);

                const data = {name: this.name, projectId: Laravel.activeProject};

                if (this.id) {
                    data.id = this.id;
                }

                const result = await api.post(data);
                this.processing = false;

                if (result.errored) {
                    this.errored = true;
                    toaster.error(this.translations.saveError);
                } else {
                    this.errored = false;
                    toaster.success(this.translations.addedSuccessfully);
                    this.refreshList();
                    this.hide();
                }
            },
        },
        mounted: function () {
            EaseEventBus.listen('tagAdd', () => {
                this.id = null;
                this.name = '';
                this.show();
            });

            EaseEventBus.listen('tagEdit', params => {
                this.id = params.id;
                this.name = params.name || '';
                this.show();
            });
        }
    }
</script>

<template>
    <dialog-base
        :maxWidth="600"
        persistent
        @close="handleClose"
        :showDialog="showDialog"
    >
        <dialog-header
            @close="handleClose"
            :title="id ? translations.editTag : translations.addTag"
        />
        <loading :loading="processing"/>
        <dialog-body>
            <div style="min-height: min-content;" class="d-flex flex-column align-center justify-center">
                <text-field class="pa-4 pb-0"
                    :label="translations.name"
                    :value="name"
                    :placeholder="translations.placeholder"
                    :rules="[nameRules.required]"
                    :error="invalid"
                    autofocus
                    @input="handleChange"
                />
            </div>
        </dialog-body>
        <dialog-actionbar v-if="showDialog"
            :disableSave="invalid"
            @close="handleClose"
            @save="handleSave"
        />
    </dialog-base>
</template>
